<!-- <nav class="navbar navbar navbar-expand-md navbar-dark">
  <div class="container-fluid mainScheduleContainer">
    <div class="navbar-brand" [routerLink]="['/dashboard']">
      <div title="SquadHub">
        <span class="header-niit-logo" title="NIIT"><img src="assets/logo.svg" alt="NIIT"></span>
          <span class="tr-logo"><span class="talent">Talent</span><span class="readiness">Readiness</span></span>
      </div>
    </div>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
      </ul>
      <ul class="navbar-nav">
        <li class="nav-item">
          <div class="headerIcons icon_1" title="Dashboard" [routerLink]="['/dashboard']">
          </div>
        </li>
        <li class="nav-item">
          <div class="headerIcons icon_4 disabled" title="Add User">
          </div>
        </li>
        <li class="nav-item">
          <a _ngcontent-c2="" title="User Profile" class="ff1" id="dropdownMenuProfileButton" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <img [src]="loginImageURL" class="profileIcon" />
            <span class="caret"></span>
          </a>
          <div class="dropdown-menu" id="dropDownPro" aria-labelledby="dropdownMenuProfileButton">
            <a class="dropdown-item cursorLink">Signed in as
              <br />
              <span>{{loginUserName}}</span>
            </a>
            <hr />
            <a class="dropdown-item" (click)="logout()">Sign out</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</nav> -->
<headerCustom></headerCustom>
<!--Functional Skill Rating Form Modal Box-->
<div *ngIf="showHideModel" class="modal fade adduserPopContainer" id="funSkillRatingPopContainer" tabindex="-1"
  role="dialog" aria-labelledby="funSkillRatingPopContainer" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <form [formGroup]="functionalSkillRatingForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">TR Nominee Functional Skill Rating Form</h5>
          <button type="button" #closeModel class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- <div class="ratingHeader">
          <span>Rating: ( 5: Strength, 4: Talented, 3: Skilled/Okay, 2: Weakness, 1: Clear Deficiency )</span>
        </div> -->
        <div class="modal-body">
          <div class="form-group row">
            <label for="level" class="col-sm-3 col-form-label control-label">Skill Levels</label>
            <div class="col-sm-9">
              <div class="row">
                <ng-container *ngFor="let skill of skillData; let i = index;">
                  <div class="col-sm-8" style="margin-bottom: 2px;">
                    <label class="form-control">{{skill.skillName}}</label>
                  </div>
                  <div class="col-sm-4">
                    <select class="form-control form-control-lg" placeholder="select skill level"
                      formControlName="{{skill.skillName}}" style="width: 135px;">
                      <ng-container *ngFor="let skillRating of skillRatingData; let i = index;">
                        <option value="{{skillRating.score}}" [selected]="skillRating.score === '5'">{{skillRating.ratingName}}</option>
                      </ng-container>
                    </select>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="skillRatingFromDate" class="col-sm-3 col-form-label control-label">Skills Rating Start
              Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.skillRatingFromDate.errors }"
                  placeholder="yyyy-mm-dd" ngbDatepicker #d1="ngbDatepicker" formControlName="skillRatingFromDate"
                  class="form-control">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setStartDate(); d1.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="skillRatingToDate" class="col-sm-3 col-form-label control-label">Skills Rating End Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input class="form-control" type="text" autocomplete="off" placeholder="yyyy-mm-dd" ngbDatepicker
                  #d2="ngbDatepicker" formControlName="skillRatingToDate">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setEndDate(); d2.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn hvr-bounce-to-top dailogButtonClass"
            (click)="onSubmit(functionalSkillRatingForm.value, true)"
            [disabled]="functionalSkillRatingForm.invalid">Submit Rating</button>
          <button type="button" class="btn hvr-bounce-to-top" data-dismiss="modal" aria-label="Close">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>

<!--Behavioral Skills Modal Box-->
<div *ngIf="showHideModel" class="modal fade adduserPopContainer" id="behavioralSkillPopContainer" tabindex="-1"
  role="dialog" aria-labelledby="behavioralSkillPopContainer" aria-hidden="true">
  <div class="modal-dialog  modal-dialog-centered" role="document">
    <form [formGroup]="behavioralSkillRatingForm">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">TR Nominee Behavioral Skill Rating Form</h5>
          <button type="button" #closeModel class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <!-- <div class="ratingHeader">
          <span>Rating: ( 5: Strength, 4: Talented, 3: Skilled/Okay, 2: Weakness, 1: Clear Deficiency )</span>
        </div> -->
        <div class="modal-body">
          <div class="form-group row">
            <label for="level" class="col-sm-3 col-form-label control-label">Skill Levels</label>
            <div class="col-sm-9">
              <div class="row">
                <ng-container *ngFor="let skill of behSkillList; let i = index;">
                  <div class="col-sm-8" style="margin-bottom: 2px;">
                    <label class="form-control">{{skill.skillName}}</label>
                  </div>
                  <div class="col-sm-4">
                    <select class="form-control form-control-lg" placeholder="select skill level"
                      formControlName="{{skill.skillName}}" style="width: 135px;">
                      <ng-container *ngFor="let skillRating of skillRatingData; let i = index;">
                        <option value="{{skillRating.score}}">{{skillRating.ratingName}}</option>
                      </ng-container>
                    </select>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="skillRatingFromDate" class="col-sm-3 col-form-label control-label">Skills Rating Start
              Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.skillRatingFromDate.errors }"
                  placeholder="yyyy-mm-dd" ngbDatepicker #d1="ngbDatepicker" formControlName="skillRatingFromDate"
                  class="form-control">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setStartDate(); d1.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="skillRatingToDate" class="col-sm-3 col-form-label control-label">Skills Rating End Date</label>
            <div class="col-sm-9">
              <div class="input-group">
                <input class="form-control" type="text" autocomplete="off" placeholder="yyyy-mm-dd" ngbDatepicker
                  #d2="ngbDatepicker" formControlName="skillRatingToDate">
                <div class="input-group-append">
                  <button class="btn hvr-bounce-to-top" (click)="setEndDate(); d2.toggle();" type="button">
                    <img src="assets/calendar-icon.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn hvr-bounce-to-top dailogButtonClass"
            (click)="onSubmit(behavioralSkillRatingForm.value, false)"
            [disabled]="behavioralSkillRatingForm.invalid">Submit Rating</button>
          <button type="button" class="btn hvr-bounce-to-top" data-dismiss="modal" aria-label="Close">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>

<sidebarWrapper></sidebarWrapper>

<div class="main-content">
<!-- Show users details in table -->
<div class="adduserContainer">
    <div class="pageContentWrapper">
      <div class="pageHeading">
        <div class="row">
          <div class="col-12">
            <div class="headerName">
              <h3>Skills Rating Section</h3>
            </div>
          </div>
        </div>
      </div>
      <div class="addUserButtonTableData" *ngIf="fetchData.length > 0">
        <div class="addSkillRatingFormLayout customizeRtsScrollBar addSkillRatingFormContainer">
          <table datatable class="table rTsCustomizeTable">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Employee Name</th>
                <th>TR Nominee Manager</th>
                <!-- <th>Type of Resource</th> -->
                <th>Functional Rating</th>
                <th>Behavioral Rating</th>
              </tr>
            </thead>
            <tbody class="text-center">
              
              <ng-container *ngFor="let fetchuserData of fetchData; let i = index;">
                <tr>
                  <td>
                    <div ngClass="{{fetchuserData.leaveUserCSS}}">{{fetchData.indexOf(fetchuserData) + 1}}</div>
                  </td>
                  <td class="addUserName">
                    <div ngClass="{{fetchuserData.leaveUserCSS}}">{{fetchuserData.userName}}</div>
                  </td>
                  <td class="userSelectType">
                    <div ngClass="{{fetchuserData.leaveUserCSS}}">{{fetchuserData.resourceManager}}</div>
                  </td>
                  <!-- <td class="userSelectType">
                    <div ngClass="{{fetchuserData.leaveUserCSS}}">{{fetchuserData.typeResource}}</div>
                  </td> -->
                  <td class="addUserButtons">
                    <div>
                      <button class="btn form-group hvr-bounce-to-top" title="Functional Skills Rating"
                        data-toggle="modal" data-target="#funSkillRatingPopContainer"
                        (click)="onEditSubmit(fetchuserData, true)">
                        <img src="assets/rating.png" />
                      </button>
                    </div>
                  </td>
                  <td class="addUserButtons">
                    <div>
                      <button class="btn form-group hvr-bounce-to-top" title="Behavioral Skills Rating"
                        data-toggle="modal" data-target="#behavioralSkillPopContainer"
                        (click)="onEditSubmit(fetchuserData, false)">
                        <img src="assets/rating.png" />
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  
</div>


<div class="loader" *ngIf="loading">
    <div class="lds-roller">
        <!-- <img src="assets/preloader.gif" />
        <span>Wait...</span> -->
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
    </div>
</div>